import PropTypes from 'prop-types';
import React from 'react';

import { propTypesNavigation } from '../Header.proptypes';

import { getStaticUrl } from '../../../../utils/getStaticUrl';

import * as S from './RootLogo.styles';

export const RootLogo = ({ document, lang }) => {
  const {
    logo_wooclap: { alt: logoWooclapAlt, localFile: localLogoWooclap } = {},
  } = document || '';

  const logoWooclapUrl = getStaticUrl(localLogoWooclap?.publicURL) || '';
  const rootLink = `https://www.wooclap.com/${
    lang === 'en-gb' ? '' : `${lang.slice(0, 2)}/`
  }`;
  return (
    <S.LogoLink href={rootLink}>
      <S.RootNav>
        <S.Logo alt={logoWooclapAlt} src={logoWooclapUrl} />
      </S.RootNav>
    </S.LogoLink>
  );
};

RootLogo.propTypes = {
  /**
   * Navigation document data from Prismic.
   */
  document: PropTypes.shape(propTypesNavigation.data),
  /**
   * Current language.
   */
  lang: PropTypes.string,
};
